import { AuthContext, Spinner } from '@enter/core';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

@(withRouter as any)
export class AcceptInvitation extends React.Component<RouteComponentProps> {
    public static contextType = AuthContext;

    public componentDidMount(): void {
        const { history, location } = this.props;
        const query = new URLSearchParams(location.search);
        const invitation_code = query.get('invitation_code');

        if (invitation_code) {
            this.context.logoutAndRedirect({
                redirect_uri: window.location.origin,
                invitation_code,
            });
        } else {
            history.replace('/');
        }
    }

    public render(): React.ReactElement {
        return <Spinner />;
    }
}
